import React from 'react'
import { withNamespaces } from "react-i18next";
import ReactCountryFlag from "react-country-flag"
import {
  Collapse,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown
} from 'reactstrap'

import { authLogout } from '../actions/auth'

const ITEM_STYLE = { color: '#2c3e50', cursor: 'pointer' }
const MENU_STYLE = { backgroundColor: '#fff' }

class DropdownLanguage extends React.Component {
  state = { value: 'en'}

  handleLangChange = (language) => {
    this.props.i18n.changeLanguage(language);
  }
  render() {
    const { t, i18n } = this.props
    return (
      <DropdownMenu className="lang-dropdown-menu" style={MENU_STYLE}>
        <DropdownItem key="es" className="lang-dropdown-item" style={ITEM_STYLE} onClick={() => this.handleLangChange('es')}>
          <ReactCountryFlag countryCode="ES" svg /> ESPAÑOL
        </DropdownItem>
        <DropdownItem key="en" className="lang-dropdown-item" style={ITEM_STYLE} onClick={() => this.handleLangChange('en')}>
          <ReactCountryFlag countryCode="GB" svg /> ENGLISH
        </DropdownItem>
        <DropdownItem key="it" className="lang-dropdown-item" style={ITEM_STYLE} onClick={() => this.handleLangChange('it')}>
          <ReactCountryFlag countryCode="IT" svg /> ITALIANO
        </DropdownItem>
        <DropdownItem key="de" className="lang-dropdown-item" style={ITEM_STYLE} onClick={() => this.handleLangChange('de')}>
          <ReactCountryFlag countryCode="DE" svg /> DEUTSCH
        </DropdownItem>
        <DropdownItem key="fr" className="lang-dropdown-item" style={ITEM_STYLE} onClick={() => this.handleLangChange('fr')}>
          <ReactCountryFlag countryCode="FR" svg /> FRANÇAIS
        </DropdownItem>
        <DropdownItem key="pt" className="lang-dropdown-item" style={ITEM_STYLE} onClick={() => this.handleLangChange('pt')}>
          <ReactCountryFlag countryCode="PT" svg /> PORTUGUÉS
        </DropdownItem>
      </DropdownMenu>
    );
  }
}
export default withNamespaces()(DropdownLanguage)
